export class SharedConstants {
  public static readonly CHAR_LIMITS: number = 5000;
  public static readonly DEBOUNCE_TIME: number = 600;
  public static readonly FORBIDDEN: number = 403;
  public static readonly UNPROCESSABLE_ENTITY: number = 422;
  public static readonly MAX_INTERNAL_POLICY_LENGTH: number = 8;
}
